/* Anavadhya — cart and contact page behaviour.
   Everything here improves a page that already works as plain forms. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function postJSON(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Something went wrong');
        return data;
      });
    });
  }

  /* ---------- Cart ---------- */
  function initCart(section) {
    if (section.__anvReady) return;
    section.__anvReady = true;
    var form = section.querySelector('[data-anv-cart-form]');

    // Quantity: update the bag as soon as it changes.
    section.querySelectorAll('[data-anv-qty]').forEach(function (select) {
      select.addEventListener('change', function () {
        var line = select.closest('.anv-line');
        if (line) line.classList.add('is-busy');
        if (form) form.submit();
      });
    });

    // Note: save quietly so it survives a refresh.
    var note = section.querySelector('[data-anv-note]');
    if (note) {
      var timer = null;
      note.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { postJSON('cart/update.js', { note: note.value }).catch(function () {}); }, 600);
      });
    }

    // Gift wrap: add it to a saree already in the bag.
    section.querySelectorAll('[data-anv-gift-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var props = {};
        try { props = JSON.parse(btn.getAttribute('data-props') || '{}') || {}; } catch (e) { props = {}; }
        props['Gift wrap'] = 'Yes';
        var line = btn.closest('.anv-line');
        if (line) line.classList.add('is-busy');
        btn.disabled = true;
        postJSON('cart/change.js', {
          line: parseInt(btn.getAttribute('data-line'), 10),
          quantity: parseInt(btn.getAttribute('data-qty'), 10) || 1,
          properties: props
        })
          .then(function () { window.location.reload(); })
          .catch(function () {
            if (line) line.classList.remove('is-busy');
            btn.disabled = false;
          });
      });
    });

    // Discount codes.
    var codeBox = section.querySelector('[data-anv-code]');
    if (codeBox) {
      var input = codeBox.querySelector('[data-anv-code-input]');
      var apply = codeBox.querySelector('[data-anv-code-apply]');
      var msg = codeBox.querySelector('[data-anv-code-msg]');
      var current = Array.prototype.map.call(codeBox.querySelectorAll('[data-anv-code-remove]'), function (b) {
        return b.getAttribute('data-anv-code-remove');
      });

      function send(codes, fresh) {
        if (msg) msg.textContent = 'Checking…';
        return postJSON('cart/update.js', { discount: codes.join(',') })
          .then(function (cart) {
            if (fresh) {
              var found = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === fresh.toLowerCase(); })[0];
              if (!found || !found.applicable) {
                if (msg) msg.textContent = 'That code can’t be used with this bag.';
                if (!found) return;
              }
            }
            window.location.reload();
          })
          .catch(function (err) { if (msg) msg.textContent = err.message; });
      }

      if (apply && input) {
        var go = function () {
          var code = input.value.trim();
          if (!code) { input.focus(); return; }
          if (current.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
            if (msg) msg.textContent = 'That code is already applied.';
            return;
          }
          send(current.concat([code]), code);
        };
        apply.addEventListener('click', go);
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); go(); }
        });
      }
      codeBox.querySelectorAll('[data-anv-code-remove]').forEach(function (b) {
        b.addEventListener('click', function () {
          var code = b.getAttribute('data-anv-code-remove');
          send(current.filter(function (c) { return c !== code; }), null);
        });
      });
    }
  }

  /* ---------- Contact ---------- */
  function initContact(form) {
    if (form.__anvReady) return;
    form.__anvReady = true;
    var params = new URLSearchParams(window.location.search);

    // /pages/contact?saree=Name fills in the saree field; ?topic=An order picks a topic.
    var saree = form.querySelector('[data-anv-saree]');
    if (saree && params.get('saree') && !saree.value) saree.value = params.get('saree');
    var topic = params.get('topic');
    if (topic) {
      form.querySelectorAll('input[name="contact[Topic]"]').forEach(function (r) {
        if (r.value.toLowerCase() === topic.toLowerCase()) r.checked = true;
      });
    }

    var done = form.querySelector('[data-anv-contact-done]');
    if (done) {
      done.scrollIntoView({ block: 'center' });
      done.focus({ preventScroll: true });
    }
  }

  function start() {
    document.querySelectorAll('[data-anv-cart]').forEach(initCart);
    document.querySelectorAll('[data-anv-contact]').forEach(initContact);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
